module.exports = __webpack_public_path__ + "static/Prasann Pandya.77164471.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Prasann Pandya.jpg
// module id = 1229
// module chunks = 6166952557895